import { FC, useCallback, useEffect, useRef, useState } from "react";
import { WithChildren } from "../../../../_metronic/helpers";
import { setReverifyHandler } from "./AuthHelpers";
import { announceVerified, markActivity, subscribeVerified } from "./idle";
import { UserReverifyModal } from "../components/user-reverify-modal/UserReverifyModal";

// Глобальный мост между 401-интерцептором (AuthHelpers) и React-деревом:
// при reverify_required интерцептор вызывает reverifyHandler(), тут открывается
// модалка, а промис резолвится/реджектится по результату действий пользователя.
const ReverifyProvider: FC<WithChildren> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const pending = useRef<{ resolve: () => void; reject: () => void } | null>(
    null
  );

  useEffect(() => {
    setReverifyHandler(
      () =>
        new Promise<void>((resolve, reject) => {
          pending.current = { resolve, reject };
          setOpen(true);
        })
    );
  }, []);

  // Окно закрылось удачно: запрос, который его открыл, можно повторять.
  const finish = useCallback(() => {
    setOpen(false);
    pending.current?.resolve();
    pending.current = null;
  }, []);

  const handleSuccess = useCallback(() => {
    // Ввод кода — работа в панели: отсчёт простоя начинается заново.
    markActivity();
    announceVerified();
    finish();
  }, [finish]);

  // Подтвердились в соседней вкладке — сессия открыта у всех, и держать здесь
  // второе окно незачем: человек уже доказал, что он на месте.
  useEffect(
    () =>
      subscribeVerified(() => {
        markActivity();
        finish();
      }),
    [finish]
  );

  const handleCancel = useCallback(() => {
    setOpen(false);
    pending.current?.reject();
    pending.current = null;
  }, []);

  return (
    <>
      {children}
      {open && (
        <UserReverifyModal onSuccess={handleSuccess} onCancel={handleCancel} />
      )}
    </>
  );
};

export { ReverifyProvider };
